import { http } from '@/platform/http'

export interface AppVersionInfo {
  id: string
  versionCode: number
  versionName: string
  downloadUrl: string
  fileSize?: string
  description?: string
  changelog?: string
  releaseDate?: string
  isActive?: number
}

export const appVersionApi = {
  latest: () => http.get<AppVersionInfo>('/public/app-version/latest', { ignoreAuth: true, toastError: false }),
}
